<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="patternAlt.altitude > 0; else addTitle">Edit Pattern Altitude</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <mat-form-field>
        <mat-select placeholder="Aircraft Class *" [(value)]="selectedAircraftClass" name="aircraftClass" formControlName="aircraftClass">
          <mat-option value="All Aircraft">All Aircraft</mat-option>
          <mat-option value="Heavy Aircraft">Heavy Aircraft</mat-option>
          <mat-option value="Light Aircraft">Light Aircraft</mat-option>
          <mat-option value="Rotorcraft">Rotorcraft</mat-option>
          <mat-option value="Turbine Aircraft">Turbine Aircraft</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput
               placeholder="Altitude (feet MSL)"
               formControlName="altitude"
               [(ngModel)]="selectedAltitude">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Pattern Altitude
</ng-template>
